<!-- stateful-internal-link component -->
<div 
  class="stateful-internal-link" 
  [attr.aria-label]="this.text + ' button'"
  *ngIf="!this.disabled"
>
  <a
    [class.has-hover]="hasHover"
    (click)="this.submit()"
    (keydown.Space)="this.submit()"
    (keydown.enter)="this.submit()"
    tabindex="0"
  >
  <ng-container *ngIf="!selected">
    <ng-container *ngIf="!isImage(text)">
      <span>{{ text }}</span>
    </ng-container>
    <ng-container *ngIf="isImage(text)">
      <img [src]="text" alt="Edit" class="image">
    </ng-container>
  </ng-container>
    <span *ngIf="this.selected">
      <kendo-loader
        [type]="loader.type"
        [themeColor]="loader.themeColor"
        [size]="loader.size"
      >
      </kendo-loader>
    </span>
  </a>
</div>